import { HydrationBoundary, QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useState } from "react"

export function TanStackQueryClientProvider({
  children,
  pageProps,
}: {
  children: React.ReactNode
  pageProps: any
}) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // With SSR, we usually want to set some default staleTime
            // above 0 to avoid refetching immediately on the client
            staleTime: 60 * 1000,
          },
        },
      }),
  )

  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={pageProps.dehydratedState}>{children}</HydrationBoundary>
    </QueryClientProvider>
  )
}
